import { createReducer } from "@reduxjs/toolkit";
import {
  EDIT_ENTITY_LOCALIZATIONS,
  ENTITY_LOCALIZATIONS_ERROR,
  ENTITY_LOCALIZATIONS_LIST,
  ENTITY_LOCALIZATIONS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
  allPages: 0,
  thisPage: 0,
};

const entityLocalizationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(ENTITY_LOCALIZATIONS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(ENTITY_LOCALIZATIONS_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(ENTITY_LOCALIZATIONS_LIST, (state, { payload }) => {
      state.loading = false;

      state.data =
        payload?.thisPage === 1
          ? payload.data
          : [...state.data, ...payload.data];
      state.allPages = payload.allPages;
      state.thisPage = payload.thisPage;
    })

    .addCase(EDIT_ENTITY_LOCALIZATIONS, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    });
});

export default entityLocalizationsReducer;
